import { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'clsx';

import withStandardWindowControls from '../../../decorators/withStandardWindowControls';
import PillButton from '../../shared/button/PillButton';
import Text from '../../Text';

import config from '../../../config';
import accountCategory from '../../../constants/analytics/categoryActionLabel/account';

import iconsCss from '../../../styles/icons.module.scss';
import css from './oauth-button.module.scss';

const {
  secureOrigin,
  oauth: {
    apple: { clientUrl, messageType },
  },
} = config;

const windowConfig = {
  width: 1180,
  height: 980,
  url: clientUrl,
};

class AppleSignInButton extends Component {
  static propTypes = {
    actionHandler: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    partnerParams: PropTypes.object,
    source: PropTypes.string,
    isPartner: PropTypes.bool,
    // from decorator
    openStandardWindow: PropTypes.func.isRequired,
    closeStandardWindow: PropTypes.func.isRequired,
  };

  static defaultProps = {
    partnerParams: {},
  };

  handleClick = () => {
    const { onClick, openStandardWindow } = this.props;
    if (onClick) onClick();
    openStandardWindow(windowConfig, this.handleOAuthMessage);
  };

  handleOAuthMessage = (event) => {
    const eventMessageType = get(event, 'data.type');
    const isInvalidOAuthMessage =
      event.origin !== secureOrigin || eventMessageType !== messageType;

    if (isInvalidOAuthMessage) {
      return;
    }

    const {
      actionHandler,
      source,
      closeStandardWindow,
      partnerParams: { partnerId },
    } = this.props;
    const { accountId: userId, token, firstName, lastName } = event.data;

    closeStandardWindow();

    const data = { userId, token, firstName, lastName };
    const params = {};

    if (partnerId) {
      params.partnerId = partnerId;
    }

    actionHandler(accountCategory.labels.apple, data, source, params);
  };

  render() {
    const { buttonText, isPartner } = this.props;

    return (
      <PillButton
        id="appleSignInOauthButton"
        className={classNames(css.appleSignInButton, {
          [css.isPartnerFlow]: isPartner,
        })}
        label={<Text name={buttonText} />}
        icon={<i className={iconsCss['icon-apple']} />}
        onClick={this.handleClick}
      />
    );
  }
}

export default withStandardWindowControls(AppleSignInButton);
